import { useTranslation } from 'react-i18next';

import { Tabs } from '@treams/treams-ui';

import useFeature from 'packages/kakapo-ui-application/hooks/useFeature';

export default function GoalsTabs() {
	const { t } = useTranslation();

	const hasGoals = useFeature('2021.goals');
	const hasTeamGoals = useFeature('2021.teamGoals');

	return (
		<Tabs.Container>
			{hasGoals && <Tabs.Item title={t('goals.tab.personal.title')} selected path="/goals" />}
			{hasTeamGoals && (
				<Tabs.Item title={t('goals.tab.collective.title')} path="/goals/collective" exact={false} />
			)}
			{hasTeamGoals && (
				<Tabs.Item title={t('goals.tab.organization.title')} selected path="/goals/organization" />
			)}
		</Tabs.Container>
	);
}
